module.exports = __webpack_public_path__ + "img/menu-cib.39993899.svg";